import React from 'react';
import PropTypes from 'prop-types';

const FlexLayout = ({
  children,
  flexDirection,
  alignItems,
  justifyContent
}) => {
  return (
    <div className="flex" style={{ flexDirection, alignItems, justifyContent }}>
      {children}
    </div>
  );
};

FlexLayout.propTypes = {
  children: PropTypes.node,
  flexDirection: PropTypes.string,
  alignItems: PropTypes.string,
  justifyContent: PropTypes.string
};

FlexLayout.defaultProps = {
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column'
};

export default FlexLayout;
